import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const PriceQuotesPageLink = () => {
  return (
    <AsideMenuLink
      pathname={P.PRICE_QUOTES_PAGE}
      subject={S.PRICE_QUOTES_PAGE}
      icon={'Price_quote_green.svg'}
      label={<FormattedMessage id="price-quotes-page-link" defaultMessage="Price quotes"/>}
    />
  );
};

export default PriceQuotesPageLink;
